import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { YEAR_MONTH } from 'utils/formatters/date'
import { Text } from 'components/text/Text'
import { formatFullNameWithMiddleInitial } from 'utils/formatters/user'

import styles from 'containers/common/greeting/FeedbackGreeting.module.scss'

export const FeedbackGreeting = ({ formData = {} }) => {
  const currentlyWorkHere = !formData.employmentToYear.value && !formData.employmentToMonth.value
  const dateFrom = moment(`${formData.employmentFromYear.value}-${formData.employmentFromMonth.value}`, 'YYYY-MM')
  const dateTo = moment(`${formData.employmentToYear.value}-${formData.employmentToMonth.value}`, 'YYYY-MM')
  const dateFromFormatted = moment(dateFrom).format(YEAR_MONTH)
  const dateToFormatted = moment(dateTo).format(YEAR_MONTH)
  const applicantNameFormatted = formatFullNameWithMiddleInitial({
    firstName: formData.firstName.value,
    lastName: formData.lastName.value,
    middleName: formData.middleName.value,
  })

  return (
    <Fragment>
      <div className={styles.name}>
        <Text size={16} lineHeight={1.38}>
          {formData.employerFirstName.value},
        </Text>
      </div>
      <div className={styles.description}>
        <Text size={16} lineHeight={1.38}>
          Thank you for considering this short questionnaire. Please answer a few questions regarding{' '}
          <strong>{applicantNameFormatted}</strong> employment at{' '}
          <strong>{formData.employmentDistrictTitle.value}</strong> during{' '}
          <strong>
            {dateFromFormatted} - {currentlyWorkHere ? 'Present' : dateToFormatted}
          </strong>{' '}
          as <strong>{formData.employmentPositionTitle.value}</strong>.
        </Text>
      </div>
    </Fragment>
  )
}

FeedbackGreeting.propTypes = {
  formData: PropTypes.object.isRequired,
}
